import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-mcommerce-virtual-cash-register-check-out-validate-payment-type-dialog',
  templateUrl: './mcommerce-virtual-cash-register-check-out-validate-payment-type-dialog.component.html',
  styleUrls: ['./mcommerce-virtual-cash-register-check-out-validate-payment-type-dialog.component.scss']
})
export class McommerceVirtualCashRegisterCheckOutValidatePaymentTypeDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<McommerceVirtualCashRegisterCheckOutValidatePaymentTypeDialogComponent>) { }

  ngOnInit() {
  }

}
